import React from 'react';
import PropTypes from 'prop-types';
import * as items from '../Items';
import Collapse from '../../Global/Collapse/Collapse';
import Button from '../../Global/Buttons/Button';
import Icon from '../../Global/Icons/Icon';
import ItemColorSelect from '../ItemColorSelect';

const DiagramCreatorShapes = ({ activeTool, toggleShape, activeColor, changeColor }) => (
  <Collapse
    show
    trigger={
      <div>
        Shapes <span className="text-grey">(click + drag)</span>
        <Icon name="arrow-down" size="m" fill="black" />
      </div>
    }
    content={
      <div className="sidebar-dropdown">
        <ItemColorSelect activeColor={activeColor} changeColor={changeColor} />

        <ul className="col-3">
          <li className={activeTool === 'square' && 'active-tool'} style={{ fill: activeColor }}>
            <Button classes="tool-btn" onClick={e => toggleShape(e, items.SQUARE)}>
              <Icon name="square" size="m" />
            </Button>
          </li>

          <li className={activeTool === 'rectangle' && 'active-tool'} style={{ fill: activeColor }}>
            <Button classes="tool-btn" onClick={e => toggleShape(e, items.RECTANGLE)}>
              <Icon name="rectangle" size="m" />
            </Button>
          </li>

          <li className={activeTool === 'circle' && 'active-tool'} style={{ fill: activeColor }}>
            <Button classes="tool-btn" onClick={e => toggleShape(e, items.CIRCLE)}>
              <Icon name="circle" size="m" />
            </Button>
          </li>
        </ul>
      </div>
    }
  />
);

DiagramCreatorShapes.propTypes = {
  activeTool: PropTypes.string,
  toggleShape: PropTypes.func,
  activeColor: PropTypes.string,
  changeColor: PropTypes.func,
};

export default DiagramCreatorShapes;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Tools/DiagramCreatorShapes.js